import React, { Component } from 'react'
import anime from 'animejs'
import Helmet from 'react-helmet'
import Flower from '../components/Flower'
import SVG from '../components/SVG'
import { fadeIn, scaleUp, translateY } from '../utils/animations'
import Header from '../components/Header'
import Logo from '../components/Logo'

export default class Home extends Component {
  componentDidMount() {
    if (!this.props.location.state)
      anime(
        fadeIn(
          [
            '#center-container',
            '#petal-nip',
            '#petal-paid',
            '#petal-vref',
            '#base',
          ],
          1000,
          null,
          200
        )
      )
    else {
      document
        .querySelectorAll([
          '.heading',
          '.text-list',
          'nav.back-button',
          '.typing-text-wrapper',
          '#animated-logo',
          '#TLcontrols',
        ])
        .forEach(i => (i.style.display = 'none'))
      anime(
        fadeIn(
          [
            '#center-container',
            '#petal-nip',
            '#petal-paid',
            '#base',
            '#petal-vref',
          ],
          200,
          () =>
            (document.getElementById('real-flower').style.display = 'block'),
          200
        )
      )
      anime(scaleUp(this.props.location.state.elementId, [10, 1], 300))
      anime(translateY('header', [-100, 0]))
    }
  }

  render() {
    return (
      <div>
        <Helmet
          title={this.props.data.site.siteMetadata.title}
          meta={[
            {
              name: 'description',
              content: this.props.data.site.siteMetadata.description,
            },
          ]}
        />
        <Header>
          <SVG
            id={'header-logo'}
            height={'48px'}
            width={'350px'}
            viewBox={'20 0 420 150'}
          >
            <Logo />
          </SVG>
        </Header>
        <main>
          <SVG id={'flower'} viewBox={`50 -40 680 700`} fitToScreen={true}>
            <Flower page={'Home'} />
          </SVG>
        </main>
      </div>
    )
  }
}

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js